import { render, staticRenderFns } from "./contentitem.vue?vue&type=template&id=39dffe50&"
import script from "./contentitem.vue?vue&type=script&lang=js&"
export * from "./contentitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports